import { makeStyles, tokens } from '@fluentui/react-components';
export var useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        backgroundColor: tokens.colorNeutralBackground2,
        boxShadow: "".concat(tokens.shadow4, ", ").concat(tokens.shadow2),
        borderRadius: tokens.borderRadiusMedium,
        overflow: 'hidden',
        boxSizing: 'border-box',
    },
    bannerImage: {
        width: '40%',
        height: '100%',
        borderRadius: tokens.borderRadiusXLarge,
        objectFit: 'cover',
        padding: '4px',
        boxSizing: 'border-box',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '0px 2rem 0px 4rem',
        width: '50%',
        maxWidth: '48%',
        zIndex: 2,
        marginBottom: '1%',
        flexWrap: 'wrap',
    },
    logoTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '12px',
        width: '298px',
        height: '52px',
        marginBottom: '32px',
        '@media(max-width: 600px)': {
            width: 'auto',
        },
    },
    logo: {
        width: '48px',
        height: '48px',
    },
    brandTitle: {
        fontFamily: tokens.fontFamilyBase,
        fontStyle: 'normal',
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase600,
        lineHeight: tokens.lineHeightBase600,
        color: tokens.colorNeutralForeground1,
        marginLeft: tokens.spacingHorizontalS,
        width: '100%',
        maxWidth: '238px',
        whiteSpace: 'nowrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        '@media(max-width: 600px)': {
            marginBottom: tokens.spacingVerticalXS,
        },
    },
    mainTitle: {
        fontFamily: tokens.fontFamilyBase,
        fontStyle: 'normal',
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeHero900,
        lineHeight: tokens.lineHeightHero900,
        color: tokens.colorNeutralForeground1,
        marginBottom: '12px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        textAlign: 'left',
        paddingBottom: '0',
        width: '100%',
        maxWidth: '580px',
        '@media(max-width: 600px)': {
            marginBottom: tokens.spacingVerticalXS,
        },
    },
    brandSubtitle: {
        fontFamily: tokens.fontFamilyBase,
        fontStyle: 'normal',
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase400,
        lineHeight: tokens.lineHeightBase400,
        color: tokens.colorNeutralForeground2,
        marginTop: '0',
        marginBottom: '32px',
        marginLeft: '0',
        paddingLeft: '0',
        paddingBottom: '0',
        alignSelf: 'flex-start',
        width: '100%',
        maxWidth: '580px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        '@media(max-width: 600px)': {
            marginBottom: tokens.spacingVerticalXS,
        },
    },
    primaryButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px',
        width: '180px',
        height: '40px',
        backgroundColor: tokens.colorBrandBackground,
        borderRadius: tokens.borderRadiusMedium,
        color: tokens.colorNeutralForegroundOnBrand,
        border: 'none',
        cursor: 'pointer',
        textAlign: 'center',
        marginLeft: '0',
        '&:hover': {
            backgroundColor: tokens.colorBrandBackgroundHover,
            color: tokens.colorNeutralForegroundOnBrand,
        },
    },
    secondaryButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px',
        width: '180px',
        height: '40px',
        backgroundColor: 'transparent',
        borderRadius: tokens.borderRadiusMedium,
        color: tokens.colorNeutralForeground1,
        border: "1px solid ".concat(tokens.colorNeutralStroke1),
        cursor: 'pointer',
        textAlign: 'center',
        marginLeft: '0',
    },
    footerSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '18px',
        padding: '16px 0',
        '@media(max-width: 600px)': {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: tokens.spacingVerticalXS,
        },
    },
});
//# sourceMappingURL=CopilotFre.styles.js.map